import { styled } from "@mui/material";
// utils
import loginBackground from "../../assets/loginBackground.png";
import ShiawaLogo from "../../assets/ShiawaLogo.png";

const BackgroundImage = styled("div")(({ theme }) => ({
  width: "100vw",
  height: 300,
  background: `url(${loginBackground}) center/100% no-repeat`,
  [theme.breakpoints.down("md")]: {
    height: 250,
  },
  [theme.breakpoints.down("sm")]: {
    background: `url(${loginBackground}) top/100% no-repeat`,
    height: "calc(100vw / 12 * 5)",
  },
}));

export const Wrapper = ({ children, title = "" }) => {
  return (
    <>
      <BackgroundImage />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            margin: "0 10px",
            width: "100%",
            maxWidth: 420,
            position: "relative",
          }}
        >
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={ShiawaLogo} alt="company-logo" style={{ maxWidth: "30%", marginTop: 24 }} />
          </div>

          {title && <h2 style={{ textAlign: "center" }}>{title}</h2>}
          {children}
        </div>
      </div>
    </>
  );
};
